export default "__VITE_ASSET__ad7c9aa0__"